import { Card } from 'components/ui/card';
import { Tooltip } from 'components/Floating/Tooltip';
import { ChartType, CHART_TYPES } from 'interfaces/chart';

import * as React from 'react';

const CHART_TYPE_LABELS: Record<ChartType, string> = {
  column: 'Colonnes',
  bar: 'Barres',
  pie: 'Camembert',
  line: 'Courbes',
  scatter: 'Nuage de points',
  bubble: 'Bulles',
  area: 'Aires',
  lineColumn: 'Courbes et colonnes',
};

type ChartTypeSelectorProps = {
  onSelect: (type: ChartType) => void;
};

export const ChartTypeSelector: React.FC<ChartTypeSelectorProps> = ({
  onSelect,
}) => {
  const handleClick = (chartType: ChartType) => {
    onSelect(chartType);
  };
  return (
    <div className="grid grid-cols-8 gap-2 my-2">
      {Object.entries(CHART_TYPES).map(([type, { Icon }]) => {
        const chartType = type as ChartType;
        const label = CHART_TYPE_LABELS[chartType] ?? type;
        return (
          <Card
            className="flex flex-col items-center p-2 cursor-pointer transition-colors hover:bg-gray-100"
            onClick={() => handleClick(chartType)}
            title={label}
            key={type}
          >
            <Tooltip content={label}>
              <Icon width={48} height={48} />
            </Tooltip>
          </Card>
        );
      })}
    </div>
  );
};
